/** Native 64px frame coordinates, measured from the skeleton body atlas (beige.png).
 * Head bounds exclude hands and equipment. Values follow the displayed frame, not elapsed time.
 * Other body atlases can supply equivalent attachment tracks without effect-specific logic.
 */
const skeletonHead: Record<string, [number, number][]> = {
    "cast-back": [[32.0,23.0],[32.0,23.0],[32.0,23.0],[32.0,23.0],[32.0,23.0],[32.0,23.0],[32.0,23.0]],
    "cast-left": [[32.5,22.0],[32.5,22.0],[32.5,22.0],[32.5,22.0],[32.5,22.0],[32.5,22.0],[32.5,22.0]],
    "cast-front": [[32.0,22.0],[32.0,22.0],[32.0,22.0],[32.0,22.0],[32.0,22.0],[32.0,22.0],[32.0,22.0]],
    "cast-right": [[31.5,22.0],[31.5,22.0],[31.5,22.0],[31.5,22.0],[31.5,22.0],[31.5,22.0],[31.5,22.0]],
    "idle-back": [[32.0,21.0]],
    "walk-back": [[32.0,21.0],[32.0,21.0],[32.0,22.0],[32.0,21.0],[32.0,21.0],[32.0,21.0],[32.0,22.0],[32.0,21.0]],
    "idle-left": [[32.5,21.0]],
    "walk-left": [[32.5,22.0],[32.5,21.0],[32.5,21.0],[32.5,21.0],[32.5,22.0],[32.5,21.0],[32.5,21.0],[32.5,21.0]],
    "idle-front": [[32.0,21.0]],
    "walk-front": [[32.0,21.0],[32.0,21.0],[32.0,22.0],[32.0,21.0],[32.0,21.0],[32.0,21.0],[32.0,22.0],[32.0,21.0]],
    "idle-right": [[31.5,21.0]],
    "walk-right": [[31.5,22.0],[31.5,21.0],[31.5,21.0],[31.5,21.0],[31.5,22.0],[31.5,21.0],[31.5,21.0],[31.5,21.0]],
    "slash-back": [[32.0,23.0],[32.0,24.0],[31.0,24.0],[33.0,23.0],[34.0,23.0],[34.0,23.0]],
    "slash-left": [[32.5,22.0],[30.5,24.0],[30.5,22.0],[29.5,22.0],[28.5,22.0],[28.5,22.0]],
    "slash-front": [[32.0,22.0],[32.0,22.0],[31.0,24.0],[34.0,23.0],[35.0,22.0],[35.0,22.0]],
    "slash-right": [[31.5,22.0],[33.5,24.0],[33.5,22.0],[34.5,22.0],[35.5,22.0],[35.5,22.0]],
}


export const headAttachment = (race: string, action: string, frame: number) => {
    if (race !== "skeleton") return undefined
    const track = skeletonHead[action] || skeletonHead[action.replace(/^idle-/, "walk-")]
    const point = track?.[Math.max(0, Math.min(track.length - 1, frame))]
    return point && { x: point[0], y: point[1] }
}

// Casting grip tracks place a small held object below the skull, between the raised palms.
// North-facing grips still locate electricity; the held object itself is occluded.
const skeletonCastingGrip: Record<string, [number, number][]> = {
    back: [[32,43],[32,42],[32,40],[32,38],[32,35],[32,32],[32,38]],
    front: [[32,43],[32,42],[32,40],[32,38],[32,35],[32,32],[32,38]],
    left: [[24,43],[24,42],[24,40],[24,38],[24,35],[24,32],[24,38]],
    right: [[40,43],[40,42],[40,40],[40,38],[40,35],[40,32],[40,38]],
}
export const castingGripAttachment = (race: string, action: string, frame: number) => {
    if (race !== "skeleton" || !action.startsWith("cast-")) return undefined
    const track = skeletonCastingGrip[action.split("-")[1]]
    const point = track?.[Math.max(0, Math.min(track.length - 1, frame))]
    return point && { x: point[0], y: point[1] }
}

const skeletonCastingHands: Record<string, [number, number, number, number][]> = {
    back: [[24,43,40,43],[20,43,44,43],[21,40,43,40],[19,38,45,38],[16,34,48,34],[17,27,47,27],[20,36,44,36]],
    front: [[24,43,40,43],[20,43,44,43],[21,40,43,40],[19,38,45,38],[16,34,48,34],[17,27,47,27],[20,36,44,36]],
    left: [[24,43,35,43],[24,42,35,42],[23,40,36,40],[22,38,38,38],[21,35,40,33],[23,30,43,27],[22,37,38,35]],
    right: [[29,43,40,43],[29,42,40,42],[28,40,41,40],[26,38,42,38],[24,33,43,35],[21,27,41,30],[26,35,42,37]],
}
export const castingHandAttachments = (race: string, action: string, frame: number) => {
    if (race !== "skeleton" || !action.startsWith("cast-")) return undefined
    const track = skeletonCastingHands[action.split("-")[1]]
    const points = track?.[Math.max(0, Math.min(track.length - 1, frame))]
    return points && [{ x: points[0], y: points[1] }, { x: points[2], y: points[3] }]
}
